import { render, staticRenderFns } from "./FormFileUploadsQuestion.vue?vue&type=template&id=73e57dc9"
import script from "./FormFileUploadsQuestion.vue?vue&type=script&lang=js"
export * from "./FormFileUploadsQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports